"use client"

import clsx from "clsx"

export default function NavigationToggle({
  className,
  toggleNavigation,
  isOpen,
}: any) {
  return (
    <button
      className={clsx(
        "flex justify-center items-center p-2 h-10 w-10 rounded border transition-all duration-300",
        isOpen
          ? "bg-grey-950 border-transparent"
          : "border-grey-850 bg-grey-850",
        className
      )}
      title={isOpen ? "Close Menu" : "Open Menu"}
      onClick={toggleNavigation}
    >
      <div
        className={clsx(
          "flex flex-wrap gap-2 w-5 h-5 transition-transform duration-300",
          isOpen ? "rotate-45" : "rotate-0"
        )}
      >
        <div className="bg-white rounded-full w-1.5 h-1.5"></div>
        <div className="bg-white rounded-full w-1.5 h-1.5"></div>
        <div className="bg-white rounded-full w-1.5 h-1.5"></div>
        <div className="bg-white rounded-full w-1.5 h-1.5"></div>
      </div>
    </button>
  )
}
